<template>
  <v-card class="mx-auto my-5 lender-card" min-width="450" max-width="450" min-height="450">

    <v-card-title :class="tier+'-tier'" class="title white--text py-0 px-6">
      <div class=tier-text>
        {{ $t('message.lenderTierName.' + tier) }}
      </div>

      <v-spacer></v-spacer>
      <v-btn v-show="tier!='PRIME'" icon block class="white--text" @click=editLender>
        <img src="static/icons/create_white.png" width="26"/>
        Edit Lender
      </v-btn>
    </v-card-title>

    <v-card-actions class="lender-image-background">
      <v-spacer/>
      <img :src="lenderImage(lender)" width="200" class="my-5"/>
      <v-spacer/>
    </v-card-actions>

    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 class="lender-name">
          {{lender.name}}
          <span v-if="lender.bankId=='snap'" class="preferred px-2">Preferred</span>
        </v-flex>
        <v-flex xs12>
          <div>
            {{ getLenderTerms(lender.bankId,'pitch') }}
          </div>
        </v-flex>
        <v-flex xs12>
          <p v-html="getLenderNote(lender)"/>
        </v-flex>
      </v-layout>
    </v-container>

  </v-card>
</template>

<script>
import LenderTermsText from '../../../static/LenderTermsText.json'

export default {
  props: {
    lender: {
      type: Object,
      required: true
    },
    tier: {
      type: String,
      required: true
    }
  },
  components: {
    LenderTermsText
  },
  methods: {
    editLender() {
      this.$emit('editLender')
    },
    lenderImage(lender) {
      if (lender.bankId) {
        return require('@/assets/images/lender/'+lender.bankId+'.png')
      } else {
        return require('@/assets/images/lender/unselected.png')
      }
    },
    getLenderNote(lender) {
      if (lender.lenderTier === 'PRIME') {
        return '<b>Note:</b> Primary cannot be changed.'
      }

      if (lender.blacklistStates && lender.blacklistStates.length > 0) {
        return '<b>Note:</b> Currently unavailable in ' + this.joinWithAnd(lender.blacklistStates) + '.'
      }

      return ""
    },
    getLenderTerms(bankid, term) {
      if (LenderTermsText[bankid]) {
        if (LenderTermsText[bankid][this.$store.getters.getDomain] && LenderTermsText[bankid][this.$store.getters.getDomain][term]) {
          return LenderTermsText[bankid][this.$store.getters.getDomain][term]
        }
        return LenderTermsText[bankid][term]
      }
      return LenderTermsText.default[term]
    }
  }
}
</script>

<style lang="scss" scoped>
.lender-card {
  border-radius: 8px;
}
.title {
  min-height: 48px;
}
.tier-text {
  font-size: 1.2rem;
}
.lender-name {
  font-size: 1.5rem;
}
.lender-image-background {
  background-color: rgb(248,248,248);
  min-height: 200px;
}
.PRIME-tier {
  background-color: rgb(64,124,43);
}
.NEAR_PRIME-tier {
  background-color: rgb(137,191,69);
}
.LEASE-tier {
  background-color: rgb(96,0,157);
}
.preferred{
  background-color: rgb(96,0,157);
  border: 1px solid hsl(209, 23%, 60%) !important;
  border-radius: 10px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Application/LenderSelectionItem.vue